import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { DocumentTemplate } from "@rumble-it/common-lib/types/models/DocumentTemplate.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const documentTemplateColumns: TableColumnsType<DocumentTemplate> = [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (_: any, record: DocumentTemplate) => (
      <Link to={`/document-templates/${record.id}`}>{record.title}</Link>
    ),
  },
  {
    title: "Taal",
    dataIndex: "language",
    key: "language",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record: DocumentTemplate) => (
      <Link to={`/document-templates/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
